import styled from '@emotion/styled';
import Phase from 'components/ChallengePortfolio/NormalView/Challenge/ChallengeView/ChallengeFields/Phase';

const PhaseName = styled(Phase.Name)({
  marginBottom: 0,
  marginRight: 'auto'
});

export default PhaseName;
